import React, { ReactNode, useEffect, useState } from 'react';

import logo from 'assets/svgs/LucidSoftwareLogo.svg';
import Link from 'components/link/link';
// import prideLogo from 'assets/LucidPride_LucidLogo.jpg';
import './navbar.scss';

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
  require('intersection-observer');
}

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0
};

interface Props {
  fadeInTrigger?: string;
  children?: ReactNode;
}

const Navbar = ({ fadeInTrigger, children }: Props) => {
  const [showNavbar, setShowNavbar] = useState(false);

  useEffect(() => {
    let observer: any = {};
    if (fadeInTrigger) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          setShowNavbar(entry.intersectionRatio === 0);
        });
      }, options);
      observer.observe(document.querySelector(fadeInTrigger));
    } else {
      setShowNavbar(true);
    }

    return () => {
      if (fadeInTrigger && observer) {
        observer.unobserve(document.querySelector(fadeInTrigger));
      }
    };
  }, [fadeInTrigger]);

  return (
    <header className={`lucid-navbar ${showNavbar ? 'show-nav' : ''}`}>
      <nav>
        <Link className="lucid-navbar-logo-link" to="/">
          <img alt="Lucid Logo" src={logo} />
        </Link>
        {!children && (
          <Link className="primary button v2" to="/careers">
            View jobs
            <span className="icon-triangle" />
          </Link>
        )}
        {children}
      </nav>
    </header>
  );
};

export default Navbar;
